// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import TaggedText from 'app/common/react/components/Activities/ActivityItems/TaggedText';
import TextButton from 'app/common/react/components/Activities/TextButton';
import { MAX_CHAR_LENGTH } from 'app/common/react/components/Activities/common';
import { Text } from 'gestalt';

type Props = {|
  allowLink?: boolean,
  allowReveal: boolean,
  inUnifiedComments?: boolean,
  maxCharLength?: number,
  tags: Array<Object>,
  text: string,
  taggedUsers: Array<Object>,
  size: 'sm' | 'md' | 'lg',
|};

type State = {|
  truncate: boolean,
|};

class TruncatedText extends React.PureComponent<Props, State> {
  static defaultProps: Props = {
    allowLink: true,
    allowReveal: false,
    size: 'md',
    tags: [],
    taggedUsers: [],
    text: '',
  };

  state: State = {
    truncate:
      !!this.props.text &&
      this.props.text.length >
        (this.props.maxCharLength || MAX_CHAR_LENGTH) + this.revealText.length,
  };

  get revealText() {
    const revealText = this.props.inUnifiedComments
      ? i18n._('... More', 'click to see more of a long post')
      : i18n._('... See more', 'click to see more of a long post');

    return revealText;
  }

  showFullText = () => this.setState({ truncate: false });

  render() {
    const { allowLink, allowReveal, maxCharLength, size, tags, taggedUsers, text } = this.props;
    const { truncate } = this.state;
    const textToShow = truncate ? text.substring(0, maxCharLength || MAX_CHAR_LENGTH).trim() : text;
    return (
      <React.Fragment>
        <TaggedText
          allowLink={allowLink}
          size={size}
          taggedUsers={taggedUsers}
          tags={tags}
          text={textToShow}
        />
        {truncate &&
          !allowReveal && (
            <Text inline weight="bold">
              {this.revealText}
            </Text>
          )}
        {truncate &&
          allowReveal && (
            <TextButton
              color="darkGray"
              handleClick={this.showFullText}
              text={this.revealText}
              size={size}
            />
          )}
      </React.Fragment>
    );
  }
}

export default TruncatedText;
